import { render, staticRenderFns } from "./QuotationProposalViewer.vue?vue&type=template&id=04641e37"
import script from "./QuotationProposalViewer.vue?vue&type=script&lang=js"
export * from "./QuotationProposalViewer.vue?vue&type=script&lang=js"
import style0 from "./QuotationProposalViewer.vue?vue&type=style&index=0&id=04641e37&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports